module.exports = __webpack_public_path__ + "static/media/nutriguideMobileMock.a7f99805.png";